import { FormDescription, FormItem, FormLabel } from '@/components/shadcn/form'
import { Button } from '@/components/shadcn/button'
import { BaseFieldProps } from './types'
import clsx from 'clsx'

export const UriField: React.FC<BaseFieldProps> = ({ field }) => {
  return (
    <FormItem className={clsx('flex flex-1 flex-col', field.widget === 'hidden' && 'hidden')}>
      <FormLabel>{field.title}</FormLabel>
      <Button
        type="button"
        variant="outline"
        onClick={() => {
          if (field.default) {
            window.open(field.default, '_blank')
          }
        }}
        disabled={field.readonly}
      >
        Download
      </Button>
      <FormDescription>{field.description}</FormDescription>
    </FormItem>
  )
}
